import React from "react";
import { useParams } from "react-router-dom";
import InnerLayout from "../../../components/layouts/inner-layout";
import ViewEWayBill from "../../../components/sales-section/e-way-bills/view-e-way-bill";

const ViewEWayBillPage = () => {
  const { id } = useParams();

  return (
    <InnerLayout backBtn={true} title="View e-Way Bill">
      <ViewEWayBill invoiceId={id} />
    </InnerLayout>
  );
};

export default ViewEWayBillPage;
